import React, {Fragment} from 'react';
import {Link} from 'react-router-dom';

import history from '../../libs/history';

import {apiCropImage} from '../../config';

//import MediaEdit from "./MediaEdit";
import MediaEdit from "../components2/mediaEdit/MediaEdit";
import MediaViewer from './MediaViewer';
import Avatar from './Avatar'
import Views from './Views';
import ImageRotation from './ImageRotation';
import Gender from './Gender';
import DateSince from './Date';
import Icon from './Icon';
import Modal from "./Modal";
import {Can} from "../../ability-context";
import createLink from "../../libs/createLink";
//import Like from "./Like/Like";
import Dotdotdot from "react-dotdotdot";
import Image from "./Image";
import {isBot, isNoFollowMedia, isNoFollowProfil, durationVideo} from "../../libs/helper";
import {contextBigPlan, BigPlanToggleSwitcher} from "../../libs/contextBigPlan";
import {useBreakpoint} from "../../libs/breakpoint";

import ThumbPrivate from "../../images/logo_symbole_carre.png";

function LikeInert({count = 0}) {
    return (
        <div className="likes auto-cursor">
            <Icon type="heart-empty"/>
            {count || 0}
        </div>
    )
}

const ThumbCount = ({count}) => {
    let {like = 0, view = 0} = count;
    return (
        <div className="thumb-topline">
            {/*{this.props._id && <Like
                            isLiked={this.props.isLiked}
                            value={this.props.count.like || 0}
                            likeType={"medias"}
                            parentId={this.props._id}
                        />}*/}
            <LikeInert count={like}/>
            <Views type="icon" value={view}/>
        </div>
    )
}

const ThumbUserRemove = (props) => {
    let {
        title = "",
        isMiniature = "",
        username = "",
        createdAt = ""
    } = props;
    return (
        <Fragment>
            <div className="row align-center full">
                <Avatar className={`img`} gender={"guest"}/>
                <div className="row full media-title">
                    <div className="title">
                        <Dotdotdot tagName="span" clamp={2} useNativeClamp={false}>
                            {title}
                        </Dotdotdot>
                    </div>
                </div>
            </div>
            <div className="row align-center mt-auto full baseline-infos">
                <div className={`infos-thumb ${isMiniature}`}>
                    <Gender gender="guest"/>
                    <div className={`link-thumb name`}>{username}</div>
                </div>
                <div className="text small medium-grey py-4 mt-8">
                    <DateSince
                        date={createdAt}
                        prefix={true}
                        currentFormat={true}
                    />
                </div>
            </div>
        </Fragment>
    )
}

const ThumbUser = (props) => {
    let {
        owner = {},
        createdAt = ""
    } = props;

    let relLinkProfil = isNoFollowProfil(owner) ? { rel: "nofollow" } : {};

    return (
        <div className="row full media-author">
            <Link to={createLink("userProfile", owner)} {...relLinkProfil}><Avatar
                width={25} height={25}
                className={`img`}
                avatar={owner?.profile?.avatar} alt=""
                gender={owner?.profile?.gender}/></Link>

            <div className="infos-thumb-text">
                <div className="infos-thumb">
                    <Link className={`link-thumb name`}
                          to={createLink("userProfile", owner)} {...relLinkProfil}>{owner.username}</Link>
                </div>
                <div className="row full media-time">
                    <DateSince
                        date={createdAt}
                        prefix={false}
                        format="DD/MM/YYYY"
                        currentFormat = {true}
                    />
                </div>
            </div>
        </div>
    )
}

const ThumbImage = (props) => {
    const breakpoints = useBreakpoint();
    let {
        thumbnailWidth = breakpoints.sm ? "650" : "222",
        thumbnailHeight = breakpoints.sm ? "650" :"222",
        previewUrl = "",
        title = "",
        imageWoker = true,
        handleImageLoaded = ()=>{},
        handleImageError = ()=>{}
    } = props;
    return (
        <Can action="clickRight" subject="Media" passThrough>
            {can => {
                return (
                    <Image
                        src={imageWoker ? apiCropImage({
                            url: previewUrl,
                            width: thumbnailWidth,
                            height: thumbnailHeight
                        }) : previewUrl}
                        onContextMenu={!can ? (e) => e.preventDefault() : null}
                        onLoad={() => handleImageLoaded()}
                        onError={(e) => handleImageError(e)}
                        alt={title}
                    />)
            }}
        </Can>
    )
}


const ThumbVideo = (props) => {
    const breakpoints = useBreakpoint();
    let {
        thumbnailWidth = breakpoints.sm ? "650" : "222",
        thumbnailHeight = breakpoints.sm ? "650" :"222",
        previewUrl = [],
        videoCoverUrl = "",
        title = "",
        state = 0,
        //duration = 0,
        handleImageLoaded = ()=>{},
        handleImageError = ()=>{}
    } = props;

    let stateStr = [
        'En attente d\'encodage',
        "",
        'Encodage en cours',
        "Erreur d'encodage",
        'Encodage en cours'
    ];

    //duration = durationVideo(duration);

    videoCoverUrl = videoCoverUrl ? `${videoCoverUrl}?width=${thumbnailWidth}&height=${thumbnailHeight}&quality=80` : ""

    return (
        <Fragment>
            <ImageRotation
                srcs={Array.isArray(previewUrl) && previewUrl.map(src => apiCropImage({
                    url: src,
                    width: thumbnailWidth,
                    height: thumbnailHeight
                }))}
                videoCoverUrl={videoCoverUrl}
                onLoad={() => handleImageLoaded()}
                onError={(e) => handleImageError(e)}
                interval={600}
                alt={title}
            />
            {state === 1 ? null : <div className="thumb-status">{stateStr[state || 0]}</div>}

            {/*<div className="btn-play">
                <Icon type="play"/>
            </div>*/}
            {/*<div className={"duration"}>{duration}</div>*/}
        </Fragment>
    )
}


class Thumb extends React.Component {
    static defaultProps = {
        title: "",
        slug: '',
        count: {
            view: 0,
            like: 0,
        },
        owner: {
            _id: 0,
            slug: '',
            username: '',
            avatar: "",
            gender: ""
        },
        authorName: "",
        previewUrl : "",
        kind : "gallery",
        videoCoverUrl : ""
    };

    constructor(props) {
        super(props);
        this.state = {
            toggle: false,
            toggleMediaEdit: false,
            imageLoading: true,
            location: history.location.pathname,
        };
        this.handleToggleMediaviewer = this.handleToggleMediaviewer.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleImageLoaded = this.handleImageLoaded.bind(this);
        this.handleImageError = this.handleImageError.bind(this);
        this.handleToggleMediaEdit = this.handleToggleMediaEdit.bind(this);
    }

    handleImageLoaded() {
        this.setState({imageLoading: false});
    }

    handleImageError(e) {
        this.setState({imageLoading: true})
    }

    handleToggleMediaEdit() {
        this.setState({toggleMediaEdit: true})
    }

    handleToggleMediaviewer(event) {
        event.stopPropagation();
        event.preventDefault();
        let search = history.location.search !== "?" ? history.location.search : "";
        let hash = history.location.hash !== "" ? history.location.hash : "";

        let location = `${history.location.pathname}${search}${hash}`;
        if(this.props.kind === "video" && this.props.file.state !== 1){
            return null
        }
        else{
            window.history.pushState("", "", createLink(this.props.kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {
                ...this.props.owner,
                media: {_id: this.props._id, slug: this.props.slug}
            }));
            this.setState({toggle: true, location});
        }

    }

    handleClose() {
        window.history.pushState("", "", this.state.location);
        this.setState({toggle: false});
    }

    render() {
        let kind = this.props.kind || "gallery";

        let loadingClass = kind === 'video' ? 'loading thumb-video' : 'loading';

        let cropTitle = this.props.cropTitle ? this.props.cropTitle : 37;
        let title = this.props.title;
        title = title.charAt(0).toUpperCase() + title.substring(1).toLowerCase();
        if (title.length > cropTitle) {
            title = title.substring(0, cropTitle) + '...';
        }

        let isBigPlan = (this.props.kind !== "video" && this.props.contentReview === 4 && !this.context?.isToggle);

        let isFriendOnly = this.context?.isAuth && this.props.right === "friends" && this.props.previewUrl === "";
        let isMembersOnly = !this.context?.isAuth && this.props.right !== "guest" && !isFriendOnly;

        if(isMembersOnly || isFriendOnly){
            isBigPlan = false
        }

        let relLinkMedia = isNoFollowMedia(this.props) ? { rel: "nofollow" } : {};
        
        if(isMembersOnly){
            relLinkMedia = {rel : "nofollow"}
        }

        return (
            <div className={`thumb ${kind === 'video' ? 'thumb-video' : ''} ${this.props.isLocked ? 'thumb-lock' : ''} ${isMembersOnly ? 'members-only' : ''} ${isFriendOnly ? 'friend-only' : ''}`}>
                <Modal toggle={this.state.toggle} handleClose={() => this.handleClose()}>
                    <MediaViewer mediaId={this.props._id} mediaSlug={this.props.slug} handleClose={this.handleClose} urlAlbum={this.state.location}/>
                </Modal>
                <Modal toggle={this.state.toggleMediaEdit} handleClose={() => this.setState({toggleMediaEdit: false})}>
                    <MediaEdit
                        handleClose={() => this.setState({toggleMediaEdit: false})}
                        callback={() => this.props.callback()}
                        currentMediaId={this.props._id}
                    />
                </Modal>


                <div className={`thumb-wrapper ${isBigPlan ? "big-plan" : ""} ${(!isBot && this.state.imageLoading) ? loadingClass : 'loaded'}`}>
                    {isMembersOnly ? (
                        <Link to={createLink("signup")} {...relLinkMedia}>
                            <ThumbImage
                                title={this.props.title}
                                previewUrl={ThumbPrivate}
                                imageWoker={false}
                                handleImageLoaded={this.handleImageLoaded}
                                handleImageError={this.handleImageError}
                            />
                            <div className="message"/>
                        </Link>
                    ) :
                     isFriendOnly ? (
                         <Link to={`${createLink("userProfile", this.props.owner)}`} {...relLinkMedia}>
                            <ThumbImage
                                title={this.props.title}
                                previewUrl={ThumbPrivate}
                                imageWoker={false}
                                handleImageLoaded={this.handleImageLoaded}
                                handleImageError={this.handleImageError}
                            />
                            <div className="message"/>
                        </Link>
                    ): (
                        <Fragment>
                            {kind !== "video" && this.props.contentReview === 4 ? <BigPlanToggleSwitcher /> : null}
                            <Link to={createLink(kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {...this.props.owner, media : {_id : this.props._id, slug : this.props.slug}})}
                                  className={"thumb-link-wrapper"}
                                  onClick={(event) => this.handleToggleMediaviewer(event)}
                                  {...relLinkMedia}
                            >
                                {kind === "video" ? (
                                    <ThumbVideo
                                        title={this.props.title}
                                        previewUrl={this.props.previewUrl}
                                        handleImageLoaded={this.handleImageLoaded}
                                        handleImageError={this.handleImageError}
                                        state={this.props.file?.state}
                                        //duration={this.props.file?.duration}
                                        videoCoverUrl={this.props.videoCoverUrl}
                                        //customCover={"https://photos.voissa.fr/albums/videos/61d34ad181a6d8bf88487f4c/61d3521d81a6d8bf885e0de2/thumbs/tn_10.jpg"}
                                    />
                                ) : (
                                    <ThumbImage
                                        title={this.props.title}
                                        previewUrl={this.props.previewUrl}
                                        handleImageLoaded={this.handleImageLoaded}
                                        handleImageError={this.handleImageError}
                                    />
                                )}
                            </Link>
                        </Fragment>

                    )}
                    {(this.props.kind === "gallery" && this.props.display ) || (this.props.kind === "video" && this.props.file?.state === 1 && this.props.display)  ? (
                        <div className={"informations-media"} >
                            <ThumbCount count={this.props.count} />
                            {this.props.kind === "video" && this.props.file?.state === 1 ? <div className={"duration"}><Icon type="play"/> {durationVideo(this.props.file?.duration || 0)}</div> : null}
                        </div>
                    ) : null}

                    {!this.props.display ? (
                        <div className={"informations-media"} >
                            <div className="thumb-topline"><div className="no-display"><Icon type={"report"} /> Invisible</div></div>
                        </div>
                    ) : null}


                    <Can action={"update"} subject={this.props} modelName="Media">
                        <div className={"edit-media"} onClick={() => this.handleToggleMediaEdit()}><Icon
                            type={"pencil"}/></div>
                    </Can>
                </div>
                <div className="wrapper">
                    {!this.props.miniatureOnly && (this.props?.owner?._id ? (
                        <Fragment>
                            <div className="row full media-title">
                                <Link to={isMembersOnly ? createLink("signup") : createLink(kind === "video" ? "mediaviewerVideo" : "mediaviewerPhoto", {
                                    ...this.props.owner,
                                    media: {_id: this.props._id, slug: this.props.slug}
                                })}
                                      className="title"
                                      {...relLinkMedia}
                                      onClick={(event) => this.handleToggleMediaviewer(event)}>
                                    <Dotdotdot tagName="span" clamp={2} useNativeClamp={false}>
                                        {title}
                                    </Dotdotdot>
                                </Link>
                            </div>
                            <ThumbUser owner={this.props.owner} createdAt={this.props.createdAt} />
                        </Fragment>
                    ) : (
                        <ThumbUserRemove
                            title={title}
                            username={this.props.authorName}
                            isMiniature={this.props.isMiniature}
                            createdAt={this.props.createdAt}
                        />

                    ))}
                </div>
            </div>
        )
    }
}

Thumb.contextType = contextBigPlan;
export default (Thumb);
